import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
    entity: {
        id: 0,
        fecha: new Date().toISOString().split('T')[0],
        idTipo: 0,
        tipo: "",
        serie: "",
        numero: "",
        idCobrador: 0,
        dniCobrador: "",
        cobrador: "",
        idPagador: 0,
        dniPagador: "",
        pagador: "",
        observaciones: "",
        idMoneda: 0,
        moneda: "",
        tipoCambio: 0.0,
        montoTotal: 0.0,
        montoSaldo: 0.0,
        saldoDisponible: 0.0,
        idEstadoPago: 0,
        estadoPago: "",
        idEstado: 0,
        estado: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listTipo: [{id: 0, descripcion: ""}],
    listMoneda: [{id: 0, descripcion: ""}],
    listEstadoPago: [{id: 0, descripcion: ""}],
    listEstado: [{id: 0, descripcion: ""}],
    listSerie: [],
    validationActive: {
        fecha: false,
        idTipo: false,
        serie: false,
        numero: false,
        idCobrador: false,
        idPagador: false,
    },
    validationMessage: [],
  }
  
  export const receiptSlice = createSlice({
    name: "receipt",
    initialState: {},
    reducers: {
      init: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setEntity: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].entity = data;
      },
      setData: (state, action) => {
        var { sliceKey, name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        
        state[sliceKey].entity[name] = value
        state[sliceKey].validationActive[name] = true
      },
      setListTipo: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listTipo = data;
      },
      setListMoneda: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listMoneda = data;
      },
      setListEstadoPago: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listEstadoPago = data;
      },
      setListEstado: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listEstado = data;
      },
      setListSerie: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listSerie = data;
      },
      setValidationMessage: (state, action) => {
        const {sliceKey, message} = action.payload;
        state[sliceKey].validationMessage = message;
      },
      activeValidations: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
          state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });
  
  export const { init, setEntity, setData, setValidationMessage, activeValidations
    , setListTipo, setListMoneda, setListEstadoPago, setListEstado, setListSerie
    } = receiptSlice.actions;
  export const defaultReceipt = {
    id: 0,
    fecha: new Date().toISOString().split('T')[0],
    idTipo: 0,
    tipo: "",
    serie: "",
    numero: "",
    idCobrador: 0,
    dniCobrador: "",
    cobrador: "",
    idPagador: 0,
    dniPagador: "",
    pagador: "",
    observaciones: "",
    idMoneda: 0,
    moneda: "",
    tipoCambio: 0.0,
    montoTotal: 0.0,
    montoSaldo: 0.0,
    saldoDisponible: 0.0,
    idEstadoPago: 0,
    estadoPago: "",
    idEstado: 0,
    estado: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
  }
  export default receiptSlice.reducer;
